import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=a2644596&scoped=true"
import script from "./agent.vue?vue&type=script&lang=ts"
export * from "./agent.vue?vue&type=script&lang=ts"
import style0 from "./agent.vue?vue&type=style&index=0&id=a2644596&lang=scss"
import style1 from "./agent.vue?vue&type=style&index=1&id=a2644596&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2644596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2644596')) {
      api.createRecord('a2644596', component.options)
    } else {
      api.reload('a2644596', component.options)
    }
    module.hot.accept("./agent.vue?vue&type=template&id=a2644596&scoped=true", function () {
      api.rerender('a2644596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/agent.vue"
export default component.exports